module.exports = __webpack_public_path__ + "static/media/bms-logo-white.8ad5ce82.png";